import React, { useCallback } from "react"
import { Grid } from "@mui/material"
import { BLACK, MEDIUM_GREY } from "../../ui/Colors"
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { useAppDispatch } from "../../../redux/hooks";
import { fetchArticles } from "../../../redux/supportAndGuides/supportArticlesSlice";

export const SupportInHeader = ({ setOpen }: { setOpen: React.Dispatch<React.SetStateAction<Boolean>> }) => {
    const dispatch = useAppDispatch()
    const _getArticles = useCallback(
        async () => await dispatch(fetchArticles()),
        [dispatch]
    )

    const handleOpenSupport = () => {
        setOpen(true)
        _getArticles()
    }

    return (<Grid
        position="relative"
        onClick={handleOpenSupport}
        sx={{ cursor: 'pointer', display: 'flex' }}
        id="openNotifications"
    >
        <HelpOutlineOutlinedIcon
            fontSize="large"
            sx={{
                width: '2.5vw',
                height: '2.5vh',
                color: BLACK,
                position: 'relative',
            }}
        />
    </Grid>)
}